import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { UseFormReturn } from 'react-hook-form';
import { AddTestForm, Resource } from 'shared/types';
import WizardConfigurationStage from './WizardConfigurationStage';
import WizardQueryFormattingStage from './WizardQueryFormattingStage';
import WizardReviewStage from './WizardReviewStage';
import WizardStage from './WizardStage';

const Wrapper = styled(Flex)`
  height: 100%;
  overflow: auto;
`;

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
  stage: number;
  keepConfigStageMounted: boolean;
  singularTestPaths?: string[];
  tableResourcesData: Resource[];
};

const AddCustomQueryTestWizardStages = ({
  methods,
  stage,
  keepConfigStageMounted,
  singularTestPaths = [],
  tableResourcesData = [],
}: Props) => (
  <Wrapper>
    <WizardStage $index={1} $selectedIndex={stage}>
      <WizardQueryFormattingStage methods={methods} />
    </WizardStage>

    {keepConfigStageMounted && (
      <WizardStage $index={2} $selectedIndex={stage}>
        <WizardConfigurationStage
          methods={methods}
          singularTestPaths={singularTestPaths}
          tableResourcesData={tableResourcesData}
        />
      </WizardStage>
    )}

    {stage === 3 && (
      <WizardStage $index={3} $selectedIndex={stage}>
        <WizardReviewStage
          watch={methods.watch}
          tableResourcesData={tableResourcesData}
        />
      </WizardStage>
    )}
  </Wrapper>
);

export default AddCustomQueryTestWizardStages;
